import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/stepin-tournament-website/stepin-tournament-website/src/legacy/components/apps/Option.tsx");
